module.exports = __webpack_public_path__ + "static/media/oberflex-erablecanadien-2560x1440.1a09de33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-erablecanadien-2560x1440.jpg
// module id = 1005
// module chunks = 37